(function () {
  'use strict';

  angular
    .module('app.page-order-task-types', []);
})();
